/*
 * @Autor: lianxiben
 * @Date: 2023-03-23 14:32:59
 * @LastEditors: lianxiben
 * @LastEditTime: 2023-05-09 15:52:15
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: `/enter*`,
    name: "enter",
    component: () => import("../views/TransitionPage/TransitionPage.vue"),
  },
  {
    path: "/",
    name: "transition",
    component: () => import("../views/TransitionPage/TransitionPage.vue"),
  },
  {
    path: "/pchome",
    name: "pchome",
    component: () => import("../views/PcHomeView/PcHomeView.vue"),
  },
  {
    path: "/home*",
    name: "homesec",
    component: () => import("../views/HomeView/HomeView.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/HomeView/HomeView.vue"),
  },
  {
    path: "/active",
    name: "active",
    component: () => import("../views/ActivePage/ActivePage.vue"),
  },
  {
    path: "/active*",
    name: "activeSec",
    component: () => import("../views/ActivePage/ActivePage.vue"),
  },
  {
    path: "/lottery",
    name: "lottery",
    component: () => import("../views/LotteryPage/LotteryPage.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
